import React from 'react';
import UserProfile from "../components/UserProfile/UserProfile";

const User = () => {
    return (
        <div>
            <UserProfile />
        </div>
    );
};

export default User;